import { formatDateTime } from '../../../../../../../lib/utils.ts';

export function byName(name: string | null): string {
    return name ? ` door ${name}` : '';
}

export function onDate(value: string | null): string {
    return value ? ` op ${formatDateTime(value)}` : '';
}
